module.exports = __webpack_public_path__ + "static/media/edward.86972e50.jpg";